import getGolfClubInfo from '../services/apis/golfCourses/getGolfClubInfo';
import { MappedGolfCourseType } from '../services/apis/golfCourses/types';

export interface CourseRatingInfo {
  rating: number | null;
  source: 'Golfamore' | 'Google' | null;
  total: number | null;
}

/**
 * Extracts the rating information from a golf course
 * Prioritizes golfhaftetRating over googleRating
 * @param course The golf course to extract rating from
 * @returns Object containing rating value, source, and total ratings
 */
const getCourseRating = (course: MappedGolfCourseType): CourseRatingInfo => {
  const info = getGolfClubInfo(course);
  if (!info) return { rating: null, source: null, total: null };

  const isGolfhaftet = !!info.golfhaftetRating;
  const ratingToUse = info.golfhaftetRating || info.googleRating;

  if (!ratingToUse) return { rating: null, source: null, total: null };

  return {
    rating: ratingToUse.rating,
    source: isGolfhaftet ? 'Golfamore' : 'Google',
    total: ratingToUse.user_ratings_total,
  };
};

export default getCourseRating;
